
<!--
 * @Author: ybl
 * @Date: 2020-07-03 15:20:30
 * @LastEditTime: 2020-08-28 18:58:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\views\maintain\StatementDetailFac.vue -->

<template>
    <div>
        <div style="width: 100%">
            <van-nav-bar
                class="restclass"
                title="结算单详情"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>

        <div>
            <van-tabs v-model="activeName" swipeable style="margin-bottom:6rem">
                <van-tab title="维修信息" name="info">
                    <van-form>
                        <van-cell-group title="报修信息">
                            <van-field v-model="formData.maintenanceType" label="维修类型" required readonly />
                            <van-field v-model="formData.faultDescription" label="故障描述" :disabled="formData.enumStatementStatus == 1" />
                            <van-checkbox v-model="formData.isOnlyRequisitionPart" shape="square" :disabled="formData.enumWorkOrderStatus != 1 || formData.enumWorkOrderType==2">仅领件</van-checkbox>
                            <el-row>
                                <div class="imgAdd" style="padding:0 0.213333rem">
                                    <span class="itemImg" v-for="(item,index) in fileList " :key="index">
                                        <img :src="item.url" alt="图片" class="uploadimg">
                                    </span>
                                </div>
                            </el-row>
                            <!-- <el-row>
                                <el-col :span="12">
                                    <van-checkbox v-model="formData.isNotMaintain" shape="square" disabled>未维修</van-checkbox>
                                </el-col>
                            </el-row> -->
                        </van-cell-group>
                        <van-cell-group title="" style='position:relative;width:100vw;'>
                            <div style='position:absolute; right:5vw;top:2vh;' @click="routetos">整车照片</div>
                        </van-cell-group>
                        <van-cell-group title="维修项目">
                            <van-list>
                                <div v-for="(item, index) in formData.items" :key="item.Id" style="margin: 5px">
                                    <MaintainItem :form-data="formData" :item="item" :index="index" @onItemClick="onItemClick($event, index,formDataCopy,formDataCopy.items[index])"
                                        @click="onItemClick($event, index,formDataCopy.items[index])" />
                                    <van-cell v-if="formData.items.length>0" title="配件明细" />
                                    <el-table v-if="formData.items.length>0" :data="item.parts" border :summary-method="getSummaries"
                                        show-summary style="width: 100%" :header-cell-class-name="'tq-table-rom-header'" size="mini">
                                        <el-table-column
                                            type="index"
                                            label="序号"
                                            width="40"
                                            align="center" />
                                        <el-table-column
                                            v-if="formData.enumWorkOrderType == 2"
                                            label="是否返修"
                                            width="60"
                                            align="center">
                                            <template slot-scope="scope">
                                                <van-switch v-model="scope.row.isRework"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    size="24px" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="billStatusName" label="状态" width="50" align="center">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName?scope.row.billStatusName:'正常' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="customerBillNo" label="出库单号">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.customerBillNo }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="part" label="配件名称" />
                                        <el-table-column prop="num" label="数量" width="50" />
                                        <el-table-column prop="unitPrice" label="单价">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.unitPrice }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="totalPrice" label="合计金额">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.totalPrice }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <van-popup v-model="showItemDetail" position="bottom">
                                        <MaintainItemDetail :detail-data="itemDetailData" :item-detail-wrok-type="itemDetailWrokType" :is-statement="isStatement" :form-item="formItem"
                                            :state-type="stateType" :form="form" @onSaveDetailClick="onSaveDetailClick" @onFaultReasonChange="onFaultReasonChange" />
                                    </van-popup>
                                </div>
                            </van-list>
                        </van-cell-group>
                        <div style='height:30vh;'></div>
                        <!-- <van-cell-group>
                            <van-col span="16" offset="4">
                                <van-button round block type="info" size="large"
                                    @click="submit">提交</van-button>
                            </van-col>
                        </van-cell-group> -->
                    </van-form>
                </van-tab>
                <van-tab title="基本信息" name="base">
                    <MaintainInfo :base-info="formData" :parent-type="parentType" :is-read-only="isReadOnly" />
                </van-tab>
            </van-tabs>
        </div>
        <Repairpopup
            v-if="equiTimingRunVisible"
            :visible.sync="equiTimingRunVisible"
            :modal-obj="modalObj"
            @onRepairPopupClose="onRepairPopupClose" />

        <!-- 签名 -->
        <el-dialog
            title="签名"
            :visible.sync="centerDialogVisible"
            width="100%"
            center>
            <sign v-if="formData.enumStatementStatus == 2" @draw_save="getSignImg" />
            <img v-if="formData.enumStatementStatus == 1 && dispatcher" :src="formData.dispatcherSignPic?imgurl+formData.dispatcherSignPic:''">
            <img v-if="formData.enumStatementStatus == 1 && driver" :src="formData.driverSignPic?imgurl+formData.driverSignPic:''">
        </el-dialog>
        <!-- 签名 -->
        <!--底部按钮 end-->
        <div style="width:100%; bottom:1.2rem;position:fixed;font-size:0.35rem;padding:10px; line-height:35px;background:#f2f2f2">
            <van-row class="Contentlist">
                <p>
                    <van-col span="6" class="moneyColTitle">金额 :</van-col>
                    <van-col span="18" class="moneyColTitle">{{ formData.total?Number(formData.total).toFixed(2):'0.00' }}</van-col>
                </p>

                <!-- <van-col span="6" class="colTitle">{{ tableData. driver }} </van-col> -->
            </van-row>
            <van-row>
                <p>
                    <van-col span="6" class="colTitle">总工签字</van-col>
                    <!--图片反显 <van-col span="7"><img :src="image1"></van-col> -->
                    <!-- <van-col span="6" class="colTitle">{{ tableData. driver }} </van-col> -->
                    <van-col sppan="2"><van-button style="background-color: transparent;" :disabled="!imgIsSuccess" @click="CanvasInit(2);dispatcher = true;driver=false"><van-icon name="coupon" size="25" style="margin-top:10px;" /></van-button>
                    </van-col>
                    <van-col span="6" class="colTitle" style="margin-left:10px;">司机签字</van-col>
                    <!--图片反显 <van-col span="7"><img :src="image1"></van-col> -->
                    <!-- <van-col span="6" class="colTitle">{{ tableData. driver }} </van-col> -->
                    <van-col sppan="2"><van-button style="background-color: transparent;" :disabled="!imgIsSuccess" @click="CanvasInit(1);driver =true;dispatcher = false"><van-icon name="coupon" size="25" style="margin-top:10px;" /></van-button>
                    </van-col>
                </p>
            </van-row>
            <van-row v-if="formData.enumStatementStatus==2 && $_has('maintain:statement:edit')" class="Contentlist" gutter="20" style="padding:0 1rem;">
                <van-col span="24">
                    <van-button round type="primary" block class="nextSpan"
                        @click="submit">提交</van-button>
                </van-col>
            </van-row>
        </div>

        <bottom />
    </div>

</template>

<script>
import bottom from '@/components/bottom'
import MaintainItem from '@/components/MaintainItem'
import MaintainInfo from '@/components/MaintainInfo'
import Sign from '@/views/maintain/Sign'
import MaintainItemDetail from '@/components/MaintainItemDetail'
import { getStateDetail, PostStateDetail, PostSign, getQualityCheckItem, qualityCheckSubmit, WorkOrderhistoryList } from '@/api/maintain'
import { Toast, Icon, Button, Col, Row, Search, Dialog } from 'vant'
import { Vue } from 'vue'
import Repairpopup from '@/views/maintain/components/repairpopup.vue'
import { isDate } from 'moment'

export default {
    name: 'StatementDetailFac',
    components: {
        bottom,
        MaintainItem,
        MaintainInfo,
        MaintainItemDetail,
        Repairpopup, Sign, Icon, Dialog
    },
    data() {
        return {
            isStatement: true,
            modalObj: {
                title: '维修历史',
                tableData: [],
                item: null
            },
            equiTimingRunVisible: false,
            activeName: 'info',
            itemDetailData: null,
            itemDetailWrokType: 0,
            partsData: null,
            showItemDetail: false,
            fileList: [],
            showPartsDetail: false,
            maintainItemIndex: -1,
            showRework: false,
            formData: {},
            canvas: null,
            ctx: null,
            penClick: false,
            startAxisX: 0,
            startAxisY: 0,
            penColor: 'yellow',
            penWidth: 4,
            imgsrc: null, // base64编码，保存为图片用到,
            IsDriverSign: 1,
            centerDialogVisible: false, // dialog弹框显示 fales不显示，true显示
            signData: {
                formFile: null, // 上传的图片文件
                realname: '1', // 文件列表展示名称
                uuid: this.$route.query.id, // 关联单据ID
                fileId: this.$route.query.id, // 文件ID，可通过此ID下载文件
                type: 1 // 类别 1签名 2附件
            },
            image1: '',
            imgIsSuccess: true,
            imgurl: process.env.VUE_APP_IMG,
            dispatcher: false,
            driver: false,
            parentType: 'settle',
            isReadOnly: false,
            formDataCopy: {},
            formItem: {},
            form: {},
            stateType: 'settle' // 正常结算单
        }
    },
    created() {
        getStateDetail(this.$route.query.id)
            .then((res) => {
                if (res.data.entranceUrl) {
                    res.data.fileList = []
                    // const picture = res.data.entranceUrl.split(';')
                    var picture = res.data.entranceUrl.split(';').filter(function(s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                    console.log(picture)
                    picture.forEach(item => {
                        res.data.fileList.push({
                            url: item
                        })
                        this.fileList.push({
                            url: item
                        })
                    })
                }
                if (res.code == 200) {
                    res.data.maintenanceType = res.data.enumMaintenanceType == 2 ? '场内维修' : '现场维修'
                    res.data.entryTime ? res.data.entryTime = res.data.entryTime.replace('T', ' ') : res.data.entryTime = ''
                    this.formData = res.data
                    this.formDataCopy = JSON.parse(JSON.stringify(res.data))
                    if (this.formData.drivers && this.formData.drivers.length > 0) {
                        this.isReadOnly = true
                    } else {
                        this.isReadOnly = false
                    }
                }
            })
    },
    methods: {
        routetos() {
            this.$router.push({ path: '/partsrepairsjiesuan', query: {id: this.$route.query.id,photos:this.formData.vehiclePicture} })
        },
        // 点击删除
        delImg(index) {
        this.submititem.entranceUrl = ''
            if (isNaN(index) || index >= this.fileList.length) {
            return false;
            }
            this.fileList.splice(index, 1);
            if(this.fileList.length>0){
                this.fileList.forEach(item=>{
                this.submititem.entranceUrl = this.submititem.entranceUrl.concat(item.url + ';')
                })
            }
            console.log(this.submititem.entranceUrl)
        },
        // 点击的时候调用相机
        clicktotakephotos(val) {
            const obj = {
                url:process.env.VUE_APP_IMG+val
            }
            this.fileList.push(obj)
            this.submititem.entranceUrl = this.submititem.entranceUrl.concat(process.env.VUE_APP_IMG + val+';')
            
        },
        clicktotakephotose() {
            window.test.openCamera('我是水印')
        },
        base64ImgtoFile(dataurl, filename = 'formFile') {
            const arr = dataurl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const suffix = mime.split('/')[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        },
        jump() {
            this.$router.push({ path: '/VehicleInfo' })
        },
        getBack() {
            this.$router.back()
        },
        onItemClick: function(item, index, form, val) {
            this.maintainItemIndex = index
            this.itemDetailData = item
            this.form = form
            this.itemDetailWrokType = this.formData.enumWorkOrderType
            this.formItem = val
            this.showItemDetail = true
        },
        getSummaries(param) {
            console.log(param)
            const { columns, data } = param
            const sums = []
            let values = []
            columns.forEach((column, index) => {
                console.log(column, index)

                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                if (column.property === 'totalPrice') {
                    values = data.map(item => Number(item['totalPrice']))
                }
                if (column.property === 'totalPrice') {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return Number(prev.toFixed(2)) + Number(curr.toFixed(2))
                        } else {
                            return Number(prev.toFixed(2))
                        }
                    }, 0)
                    if (sums[7]) {
                        sums[7] = Number(sums[index]).toFixed(2)
                    } else {
                        sums[6] = Number(sums[index]).toFixed(2)
                    }

                    sums[index]
                } else {
                    sums[index]
                }
            })

            return sums
        },
        getTotal() {
            var i = 0
            var totalTmp = 0
            console.log(' this.formData.items.length:' + this.formData.items.length)
            for (i; i < this.formData.items.length; i++) {
                totalTmp += Number(this.formData.items[i].totalPrice)

                var j = 0
                /* console.log('this.formData.items[i].totalPrice:' + this.formData.items[i].totalPrice)
                console.log('this.formData.items[i].parts.length:' + this.formData.items[i].parts.length)*/
                for (j; j < this.formData.items[i].parts.length; j++) {
                    totalTmp += Number(this.formData.items[i].parts[j].totalPrice)
                }
            }
            this.formData.total = Number(totalTmp).toFixed(2)
        },
        onSaveDetailClick: function(data) {
            this.showItemDetail = false
            if (this.maintainItemIndex > -1) {
                this.formData.items[this.maintainItemIndex].enumQualityInspectionResult = data.qualityInspectionResultVal
                this.formData.items[this.maintainItemIndex].enumFaultReason = data.faultReasonVal
                this.formData.items[this.maintainItemIndex].statementMen = data.workerList
                this.formData.items[this.maintainItemIndex].workHour = data.workHour
                this.formData.items[this.maintainItemIndex].maintainItemNum = data.maintainItemNum
                this.formData.items[this.maintainItemIndex].totalPrice = data.totalPrice
                this.formData.items[this.maintainItemIndex].stationName = data.stationName
                this.formData.items[this.maintainItemIndex].maintenTypeName = data.maintenTypeName
                this.getTotal()
            }
        },
        onFaultReasonChange: function(data) {
            console.log(data)
            if (data.text === '配件质量' || data.text === '维修装配') {
                this.equiTimingRunVisible = true
                this.showItemDetail = false

                WorkOrderhistoryList({ vehicleId: this.formData.vehicleId, maintainItemId: data.maintainItemId, partId: data.partId }).then(res => {
                    this.modalObj.tableData = res.data
                })
            }
        },
        onRepairPopupClose: function() {
            this.formData.items[this.maintainItemIndex].enumFaultReason = 1 // 自然损坏
        },
        onSubmit() {
            qualityCheckSubmit(this.formData)
                .then(res => {
                    if (res.isSuccess) {
                        // 提交成功
                        Toast.success('提交成功')
                        this.$router.push({ path: '/StatementList' })
                    } else {
                        Toast.success(res.message)
                    }
                })
        },
        async submit() {
            // Vue.set(this.formData, 'workers', '')
            console.log('DispatcherSignPic:' + this.formData.DispatcherSignPic)
            console.log('driver:' + this.formData.DriverSignPic)
            console.log('this.formData.EnumStatementStatus:' + this.formData.EnumStatementStatus)
            if (this.formData.DriverSignPic == undefined || this.formData.DriverSignPic == '') {
                this.popup('司机未签字')
                return
            }
            if (this.formData.DispatcherSignPic == undefined || this.formData.DispatcherSignPic == '') {
                this.popup('总工未签字')
                return
            }
            if (this.formData.drivers && this.formData.drivers.length > 2) {
                Toast.fail('最多绑定两个驾驶员')
                return
            }
            // if (this.formData.drivers.length == 0) {
            //     Toast.fail('请填写驾驶员')
            //     return
            // }
            if(this.formData.isOnlyRequisitionPart){
                this.formData.items[0].workHour=0
            }
            const res = await PostStateDetail(this.formData)
            if (res.isSuccess) {
                this.$message({
                    message: res.message,
                    type: 'success'
                })
                this.$router.push({ path: '/StatementList' })
            }
        },
        async upSign() {
            if (this.imgsrc) {
                // this.imgsrc  base64编码的图片
                var imgFile = this.base64ImgtoFile(this.imgsrc)// 转换图片文件
                const formData = new FormData()
                formData.append('file', imgFile) // 图片
                this.signData.fileId = this.signData.uuid
                const params = {
                    fileId: this.signData.fileId,
                    type: 1
                }
                formData.append('guid', params.fileId)// json格式上传
                formData.append('category', params.type)

                const res = await PostSign(formData)
                debugger
                if (res.code === 200) {
                    console.log('############################' + res.url)
                    // this.image1 = 'http://47.99.52.157:9007' + res.data
                    // / 司机签字图片
                    console.log('IsDriverSign：' + this.IsDriverSign)
                    if (this.IsDriverSign == 1) {
                        console.log('司机：' + res.url)
                        this.formData.DriverSignPic = res.url
                        console.log('司机：' + this.formData.DriverSignPic)
                    }
                    // /总工签字图片
                    if (this.IsDriverSign == 2) {
                        console.log('总工：' + res.url)
                        this.formData.DispatcherSignPic = res.url
                        console.log('总工：' + this.formData.DispatcherSignPic)

                        // Vue.set(this.formData, 'DispatcherSignPic', res.data)
                        console.log('总工1：' + this.formData.DispatcherSignPic)
                        // this.formData.DispatcherSignPic =res.data;
                        if (this.formData.DispatcherSignPic && this.formData.DriverSignPic) {
                            this.formData.EnumStatementStatus = 1
                        }
                    }
                } else {
                    this.imgIsSuccess = false
                }
            }
        },
        getSignImg(val) {
            // val 是接收子组件的data的
            this.imgsrc = val // 让签的名变成图片
            this.centerDialogVisible = false
            this.upSign()
        },
        async popup(msg) {
            Dialog.alert({
                title: '提示',
                message: msg,
                asyncClose: true
            })
        },
        async CanvasInit(IsDriver) {
            console.log('IsDriver' + IsDriver)
            console.log('this.formData.EnumStatementStatus:' + this.formData.EnumStatementStatus)
            if (this.formData.EnumStatementStatus == 1) {
                this.centerDialogVisible = false
                await this.popup('已签字')
                return
            } else {
                this.centerDialogVisible = true
                this.IsDriverSign = IsDriver
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.content{
    padding: 16px;
    padding-top: 10px;
}
.moneyColTitle{
    font-size: 0.65rem;
    color:red;
    line-height: 1.5rem;
}
.colTitle{
    font-size:0.5rem
}
</style>
